/* import __COLOCATED_TEMPLATE__ from './card-invitation-management.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { ResendToastStatus } from '@banking/ui/workflows/card-invitation-management';

/**
 * NOTE(cvu): There are a few states in this presentation component and to make it easier for
 * myself, I am going to categorize them. This state will be dictated by whatever functionality.
 */
export let InvitationManagementState = /*#__PURE__*/function (InvitationManagementState) {
  InvitationManagementState["Loading"] = "LOADING";
  InvitationManagementState["ActiveInvitation"] = "ACTIVE_INVITATION";
  InvitationManagementState["CanceledInvitation"] = "CANCELED_INVITATION";
  InvitationManagementState["Error"] = "ERROR";
  return InvitationManagementState;
}({});
let CardInvitationManagement = (_class = class CardInvitationManagement extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "InvitationManagementState", InvitationManagementState);
    _initializerDefineProperty(this, "cardPreview", _descriptor, this);
    _initializerDefineProperty(this, "infoText", _descriptor2, this);
    _initializerDefineProperty(this, "hasActiveInvitation", _descriptor3, this);
    _defineProperty(this, "ResendToastStatus", ResendToastStatus);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cardPreview", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      businessName: this.args.businessName,
      cardholder: '',
      customizationImageDataURL: '',
      cvc: '',
      expirationDate: '',
      fullPan: ''
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "infoText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hasActiveInvitation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class);
export { CardInvitationManagement as default };